import { noddiAsync, URLKeys } from 'noddi-async';
import { groupCars } from 'noddi-util';
import { useBookingAddress, useBookingSelectedSalesItemsCars } from 'noddi-web';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';

/**
 * Whether the drafted cars need us at the customer, as the backend decides it from the cart. Without a visit (wheel
 * storage only, picked up at another tire hotel) the booking takes no delivery window.
 */
export function useMobileBookingNeedsCustomerVisit({ enabled }: { enabled: boolean }) {
  const selectedAddress = useBookingAddress();
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();
  const { currentBrand } = useCurrentBrand();

  const { data, isPending, error } = noddiAsync.usePostAsGetQuery({
    type: URLKeys.postGetShoppingCartForNewBooking,
    input: {
      addressId: selectedAddress?.id as number,
      cars: groupCars(selectedSalesItemsCars),
      brandDomain: currentBrand
    },
    queryConfig: {
      enabled: enabled && !!selectedAddress,
      staleTime: Infinity
    }
  });

  return { needsCustomerVisit: data?.data.needsCustomerVisit, isPending, error };
}
